export class OrderDetails {
  links: Array<any>;

  constructor(_id: number, filters) {
    this.links = [
      {
        link: "/orders/" + _id,
        filters: filters,
        label: "Details",
        page: "details",
      },
      {
        link: "/orders/" + _id + "/docs",
        filters: filters,
        label: "Docs",
        page: "docs",
      },
      {
        link: "/orders/" + _id + "/invoices",
        filters: filters,
        label: "Invoices",
        page: "invoices",
      },
      {
        link: "/orders/" + _id + "/history",
        filters: filters,
        label: "History",
        page: "history",
      },
    ];
  }
}
